import { z } from 'zod';

export const translationResultSchema = z.object({
  title: z.string().min(1),
  definition: z.string().min(1),
  definitionSimple: z.string().nullable().optional().default(null),
  usageNotes: z.string().nullable().optional().default(null),
  examples: z
    .array(z.object({ id: z.number(), translated: z.string() }))
    .max(10)
    .optional()
    .default([]),
});

export type ITranslationResult = z.infer<typeof translationResultSchema>;

export function buildTranslationResultSchema(options: {
  requireDefinition: boolean;
}): z.ZodType<ITranslationResult> {
  if (options.requireDefinition) {
    return translationResultSchema;
  }
  return translationResultSchema.extend({
    definition: z
      .string()
      .nullish()
      .transform((value) => value ?? ''),
  });
}
